import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-PriceList',
    templateUrl: './PriceList.component.html',
    styleUrls: ['./PriceList.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PriceListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
